var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.issue)?_c('section',{staticClass:"issue-card-short"},[_c('i',{staticClass:"gf-icon gf-icon-alert gf-fs-2",style:({ color: _vm.issueColor })}),_c('a',{attrs:{"href":_vm.issueLink}},[_vm._v("#"+_vm._s(_vm.issue?.localId))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.issue?.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }